<template>
    <div class="tab-content scroll" :class="[blockType+'-props', {'sidebar_edit_lock': model.editLock}]" v-if="model.attributes">

        <responsiveToggle
            title="Responsive"
            :value="model.responsive"
            @updated="debUpdate($event, 'responsive')"
        />

	    <template v-for="(item, name, index) in basic" >
		    <keep-alive>
			    <component :key="`props_basic_${item.comp}`"
					    :is="item.comp"
					    :value="item.value"
					    :title="item.title"
					    :options="item.options"
					    :content="content"
					    @updated="debUpdate($event, name)" />
		    </keep-alive>
	    </template>


	    <div class="sidebar_edit_lock_overlay" v-if="model.editLock">
		    <h3>Element editing is locked!</h3>
		    <h4>Disable the lock to edit.</h4>
	    </div>
    </div>
</template>

<script>
import sidebarItems from '@/modules/page-editor/src/components/sidebar/sidebar-items/'
import { mapGetters } from "vuex"
import models from '@/modules/page-editor/src/models/'
import debounceAction from "@/helpers/debounce"

export default {
    name: 'PropertiesPanelBasic',
    components: {
        ...sidebarItems
    },
    data: function(){
        return {
            model: '',
            blockType: ''
        }
    },
    props: ['content'],
    computed: {
        ...mapGetters(['page_findOne',  'page_id', 'page_tab']),
        id(){
            return this.page_id
        },
        labelTitleComp(){
            return (this.model.labelTitle)
        },
        labelColorComp(){
            return (this.model.labelColor)
        },
        basic() {
            for(var index in this.content.attributes.basic) {
                if(this.content.attributes.basic[index] && this.model.attributes.basic[index]) {
                    this.model.attributes.basic[index].value = this.content.attributes.basic[index];
                }
            }
            return this.model.attributes.basic
        }
    },
    methods: {
        init(id) {
            this.model = '';
            this.blockType = this.content.type;

            this.model = JSON.parse(JSON.stringify(models[this.blockType]));

            this.model.id = this.content.id;
            this.model.labelTitle = this.content.labelTitle || 'Section';
            this.model.labelColor = this.content.labelColor || '#ffffff';
		        this.model.editLock = this.content.editLock || false;
            this.model.responsive = this.content.responsive || { mobile: true, tablets: true, desktop: true };
        },
        debUpdate: debounceAction(function(event, field) {
            this.onFieldUpdate(event, field)
        }, 100),
        onFieldUpdate(event, field) {
	        if(this.model.editLock !== undefined && this.model.editLock) {
		        console.log('EDIT LOCKED!');
	        } else {
		        if (field == 'labelColor' || field == 'labelTitle' || field == 'responsive') {
			        this.model[field] = event;
			        this.$store.dispatch('PAGE_EDIT_FIELD', {id: this.page_id, field, value: event, type: this.blockType});
		        } else {
		        	this.$set(this.model.attributes.basic[field], 'value', event)
			        // this.model.attributes.basic[field].value = event;
			        this.$store.dispatch('PAGE_EDIT_FIELD', {
				        id: this.page_id,
				        field,
				        value: event,
				        type: this.blockType,
				        tab: this.page_tab
			        });
		        }
	        }
        },
    },
    created() {
        this.init(this.page_id);
    },
}
</script>
